module.exports = __webpack_public_path__ + "img/y2.201d16de.png";